/* istanbul ignore file */
import { datadogLogs } from '@datadog/browser-logs'
import { getGlobalConfig } from '@/utils/globalConfig'

let _logger = console

if (getGlobalConfig('Datadog.logging.enabled') === true) {
  if (getGlobalConfig('Datadog.logging.env')) {
    datadogLogs.setLoggerGlobalContext({ env: getGlobalConfig('Datadog.logging.env') })
  }

  const datadogLogsConfiguration = {
    clientToken: getGlobalConfig('Datadog.logging.clientToken'),
    site: getGlobalConfig('Datadog.logging.site'),
    forwardErrorsToLogs: true,
    forwardConsoleLogs: 'all',
    sampleRate: 100
  }

  datadogLogs.init(datadogLogsConfiguration)

  _logger = datadogLogs.logger
  console.log('Using Datadog logger')
}

const logger = {
  info (message, ...data) {
    _logger.info(message, ...data)
  },
  warn (message, ...data) {
    _logger.warn(message, ...data)
  },
  error (message, ...data) {
    _logger.error(message, ...data)
  },
  log (message, ...data) {
    _logger.log(message, ...data)
  }
}

export { logger }
